import axios from "axios"
import {xAuth,baseUrl,service} from "../utils/constant";


const error={"code":400,"message":"Internet not connected on your device."};
const token = localStorage.getItem('token');
const headers = {
    'Content-Type': 'application/json',
    'x-auth': xAuth
  }
//let url="";

const postRequest = async (action, body) => {
    try {
        headers.Authorization='Bearer '+token; 
        const resp = await axios.post(baseUrl+action, body,{headers:headers});
        const data = await resp.data;        
        return [null, data];
    } catch (e) {
        setResponse(e);
        return [e]
    }
}
const getRequest = async (action) => {
    try {
        headers.Authorization='Bearer '+token; 
        const resp = await axios.get(baseUrl+action,{headers:headers});
        const data = await resp.data;
        return [null, data];
    } catch (e) {
        setResponse(e);
        return [e]
    }
}

const handleMessage = (msg_type, pack) => {
   
    switch (msg_type) {
        case "noSub":
            return "Dear user you are not a subscriber of kidzmania service. To subscribe click below";
        case "sub":
            return `Thank you for your request for kidzmania service ${pack} at ${
                pack === "Daily" ? "2" : "10"
               } leones. We are redirecting you to content`;
        case "exist":
            return "Dear user you are already a subscriber of kidzmania service. You will be redirected to content page."
        default :
            return "";
    }
}

const loaderHandler = async (setLoadermsg, ms) => {
    const msgS = [
        "Wait a sec...",
        "Taking longer then expected...",
        "Almost there..",
    ];

   for (let i = 0; i < msgS.length; i++) {
        setLoadermsg(msgS[i]);
        await sleep(ms)
   }
}

const sleep = async (ms) => {
    return new Promise((resolve) => {
        setTimeout(resolve, ms * 1000)
    })
}
function setResponse(e)
{   
    if(e.response!=null && e.response!=undefined && e.response.status===401){
        localStorage.clear();
        window.location.href ="/login";
    }
    else {return e}
}

export { postRequest,getRequest, handleMessage, loaderHandler, sleep }